import { get } from "lodash";
import { MESSAGE_DESCRIPTIONS, DEFAULT_TITLE, DEFAULT_DESCRIPTION, DEFAULT_IMAGE } from "./messageDescriptions";

export const selectModal = (state, modal) => get(state, `modals.${modal}`, false);
export const selectModalMessageCode = (state) => get(state, "modals.messageCode", null);
export const selectModalTitle = (state) => get(MESSAGE_DESCRIPTIONS, `${selectModalMessageCode(state)}.title`, DEFAULT_TITLE);
export const selectModalDescription = (state) => get(MESSAGE_DESCRIPTIONS, `${selectModalMessageCode(state)}.description`, DEFAULT_DESCRIPTION);
export const selectModalImage = (state) => get(MESSAGE_DESCRIPTIONS, `${selectModalMessageCode(state)}.image`, DEFAULT_IMAGE);
export const selectParams = (state) => get(state, "modals.params", {});
